//
import Service from '@/services/api/service'
import CustomerReceivablePaymentPaymentsModel from '@/models/POS/PosPaymentsCustomerReceivablePayment'

//
import headers  from './headers'

//
export default class extends Service {

    //
    static headers  = headers
    
    //
    static model = CustomerReceivablePaymentPaymentsModel
}
